import { rootElement } from '@shared/setup';
import DynamicSubjectEditor from './DynamicSubjectEditor.vue';

const initDynamicSubjectEditor = async () => {
    rootElement({
        name: 'dynamic-subject-editor',
        component: DynamicSubjectEditor,
        vm: {},
        contextComponents: ['<div>Loading statistics...</div>'],
    });
};

initDynamicSubjectEditor();

